import React from 'react';
export var HedinUIContextDefault = {
  i18nInstance: null,
  testProperty: 'Hello world!',
  placeholderGenerator: undefined,
  sitecoreContext: null
};
export var HedinUIContext = /*#__PURE__*/React.createContext({
  i18nInstance: null,
  testProperty: 'Hello world!',
  placeholderGenerator: null,
  sitecoreContext: null
});